import React from 'react';
const SvgProcessing = React.forwardRef((rest, ref) => {
  const props = { ...rest, ref };
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 100 100"
      preserveAspectRatio="xMidYMid"
      className="processing_svg__uil-ring"
      {...props}
    >
      <path fill="none" className="processing_svg__bk" d="M0 0h100v100H0z" />
      <circle
        cx={50}
        cy={50}
        r={46}
        strokeDasharray="231.22121930420877 57.80530482605218"
        stroke="#4990e2"
        fill="none"
        strokeWidth={8}
      >
        <animateTransform
          attributeName="transform"
          type="rotate"
          values="0 50 50;180 50 50;360 50 50;"
          keyTimes="0;0.5;1"
          dur="2s"
          repeatCount="indefinite"
          begin="0s"
        />
      </circle>
    </svg>
  );
});
export default SvgProcessing;
SvgProcessing.iconName = 'processing';
SvgProcessing.displayName = 'SvgProcessing';
